/* Vornom cart drawer and cart page additions (snippets/vor-cart-drawer, sections/vor-main-cart). Port of
   upp-theme assets/upp-cart.js (5950f48) without its US parts (delivery add-ons and their clean-up,
   checkout lead-time properties) and without the chair suggestion (T8, wave 2).
   Impulse's theme.CartDrawer / theme.CartForm (assets/theme.js, Vornom's 0ae2dad: opens on the tap,
   refills [data-products] from the add / change response) do the work; this file only:
   - points the theme at sections/vor-cart-ajax (theme.cart.drawerSection, and the page-load fetch),
     so the new markup refills the new drawer; the old drawer and its section stay as they are
   - copies the Liquid-formatted totals (no trailing zeros) into the footer, the header count and the
     taksit line after every refill
   - "Sepete eklendi: <ürün> (<ölçü>) ve N sandalye" after an add (boards 03-04)
   - Remove (and minus at 1) without leaving the page (theme.cart.changeItem + the theme's cart:build)
   - the "Sipariş notu ekle" toggle, focus kept on the control that was used
   - A23 required consent (snippets/vor-cart-consent): the checkout button is rendered disabled, this file
     enables it and from then on keeps it aria-disabled so a blocked click still shows the error and moves
     focus; it does not submit until the box is ticked. Ticking writes the cart attribute "Sözleşme onayı"
     (evet · ISO time) and the same value into the form's hidden attributes[] input, so the record survives
     a failed /cart/update.js; that write is retried once and, if it still fails, the express buttons stay
     hidden (they skip the form). sessionStorage "vor-consent" keeps the tick in the tab; express buttons
     on /cart show only once ticked
   GA4: none here (begin_checkout comes from the app; vor-events.js has no cart events). */
(function () {
  'use strict';
  if (window.__vorCart) return;
  window.__vorCart = true;

  var drawer = document.querySelector('#CartDrawer[data-vor-cart]');
  var page = document.querySelector('#CartPageForm[data-vor-cart]');
  if (!drawer && !page) return;

  var SECTION = 'vor-cart-ajax';
  var CHECK = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false"><path d="M5 12l4 4 10-10"/></svg>';

  /* The new markup comes from sections/vor-cart-ajax: in add / change responses (drawerSection) and
     on page load (the theme's getCartProductMarkup asks /cart?view=ajax, the old markup, so it asks
     for the section instead). theme.js is deferred earlier in the page and, as the document is no
     longer "loading" when deferred scripts run, it builds the drawer at once, before this file: that
     first page-load fill can bring the old markup. wire() spots it (no data-vor-total on .cart__items)
     and asks the theme to build again (cart:build without sections -> buildCart -> this override).
     Seen on the 390 test 2026-10-20: drawer opened on a product page with 3 items and no new lines. */
  if (window.theme && theme.cart) {
    theme.cart.drawerSection = SECTION;
    theme.cart.getCartProductMarkup = function () {
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      return fetch(root + 'cart?section_id=' + SECTION + '&t=' + Date.now(), { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .catch(function (e) { console.error(e); });
    };
  }

  // The drawer is printed inside the header section, which is sticky with its own z-index, so the
  // page overlay would sit above it. Hang it off <body> instead; the node and its listeners stay.
  if (drawer && drawer.parentElement !== document.body) document.body.appendChild(drawer);

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function keySel(k) { return '.vor-cl[data-key="' + (window.CSS && CSS.escape ? CSS.escape(k) : k) + '"]'; }

  // root: #CartDrawer or #CartPageForm
  function wire(root, isDrawer) {
    var products = root.querySelector('[data-products]');
    if (!products) return;
    var addedEl = root.querySelector('[data-vor-added]');
    var countEl = root.querySelector('[data-vor-cart-count]');
    var subEl = root.querySelector('[data-vor-items-subtotal]');
    var totalEl = root.querySelector('[data-subtotal]');
    var busyEl = isDrawer ? root : root.parentNode;
    var refocus = null;

    // The size comes from the refilled line (data-vor-line-size, cm); until the refill lands,
    // Shopify's variant title stands in. Chairs added with a table come as "<title> + N sandalye"
    // (assets/vor-pdp.js) and read "… ve N sandalye". The title is cut at its first " - " or ","
    // (Vornom titles carry an SEO tail).
    var lastAdded = null;
    function showAdded(item) {
      if (!addedEl || !item || !item.product_title) return;
      lastAdded = item;
      var raw = String(item.product_title);
      var chairs = raw.match(/ \+ (\d+) sandalye$/);
      if (chairs) raw = raw.slice(0, chairs.index);
      var title = raw.split(/ [-–] |,/)[0].trim();
      var line = item.key ? products.querySelector(keySel(item.key)) : null;
      var size = line && line.hasAttribute('data-vor-line-size') ? line.getAttribute('data-vor-line-size') : (item.variant_title || '');
      var qty = item.quantity > 1 ? item.quantity + ' × ' : '';
      var text = qty + title + (size ? ' (' + size + ')' : '') + (chairs ? ' ve ' + chairs[1] + ' sandalye' : '');
      addedEl.innerHTML = CHECK + '<span>Sepete eklendi: ' + esc(text) + '</span>';
    }
    function clearAdded() { lastAdded = null; if (addedEl) addedEl.innerHTML = ''; }

    // After every refill of [data-products] (page load, add, quantity change, remove).
    function sync() {
      var items = products.querySelector('.cart__items');
      if (!items) return;
      var n = parseInt(items.getAttribute('data-count'), 10) || 0;
      if (!isDrawer && n === 0) { window.location.reload(); return; }
      if (countEl) countEl.textContent = n > 0 ? ' (' + n + ')' : '';
      if (subEl && items.dataset.vorSubtotal) subEl.textContent = items.dataset.vorSubtotal;
      if (totalEl && items.dataset.vorTotal) totalEl.textContent = items.dataset.vorTotal;
      var tk = root.querySelector('[data-vor-taksit-amount]');
      if (tk && items.dataset.vorTaksit) tk.textContent = '6 × ' + items.dataset.vorTaksit;
      var tkTotal = root.querySelector('[data-vor-taksit-total]');
      if (tkTotal && items.dataset.vorTotal) tkTotal.textContent = items.dataset.vorTotal;
      if (lastAdded && addedEl && addedEl.innerHTML) showAdded(lastAdded);
      if (!refocus) return;
      var r = refocus;
      refocus = null;
      var target = null;
      var line = r.key ? products.querySelector(keySel(r.key)) : null;
      if (line) {
        target = line.querySelector(r.sel);
        if (target && target.disabled) target = line.querySelector('.js-qty__adjust--plus');
      }
      if (!target && r.fallback) target = root.querySelector(r.fallback);
      if (target && (!isDrawer || root.classList.contains('drawer--is-open'))) target.focus({ preventScroll: isDrawer });
    }
    // Only a real refill (a new .cart__items), not the placeholder row added on the tap.
    var rebuiltAt = 0;
    new MutationObserver(function (records) {
      var refilled = records.some(function (r) {
        return Array.prototype.some.call(r.addedNodes, function (n) { return n.classList && n.classList.contains('cart__items'); });
      });
      if (!refilled) return;
      var items = products.querySelector('.cart__items');
      if (items && !items.hasAttribute('data-vor-total') && Date.now() - rebuiltAt > 5000) {
        rebuiltAt = Date.now();
        document.dispatchEvent(new CustomEvent('cart:build'));
        return;
      }
      sync();
    }).observe(products, { childList: true });
    // the old fill may have landed before this file ran
    var early = products.querySelector('.cart__items');
    if (isDrawer && early && !early.hasAttribute('data-vor-total')) {
      rebuiltAt = Date.now();
      document.dispatchEvent(new CustomEvent('cart:build'));
    }

    if (isDrawer) {
      // Clear the "Eklendi" line when the drawer closes (open -> closed only).
      var wasOpen = root.classList.contains('drawer--is-open');
      new MutationObserver(function () {
        var open = root.classList.contains('drawer--is-open');
        if (wasOpen && !open) clearAdded();
        wasOpen = open;
      }).observe(root, { attributes: true, attributeFilter: ['class'] });
      document.addEventListener('ajaxProduct:adding', clearAdded);
      document.addEventListener('ajaxProduct:added', function (evt) {
        showAdded(evt.detail && evt.detail.product);
      });
    }

    // Remove without leaving the page; the /cart/change link is the fallback.
    function removeLine(line, rm) {
      if (rm.hasAttribute('data-vor-removing')) return; // a double tap would send the key twice
      rm.setAttribute('data-vor-removing', '');
      clearAdded();
      busyEl.classList.add('is-updating');
      var lines = Array.prototype.slice.call(products.querySelectorAll('.vor-cl'));
      var i = lines.indexOf(line);
      var next = lines[i + 1] || lines[i - 1];
      var fallback = isDrawer ? '#CartDrawerTitle' : null;
      refocus = next ? { key: next.getAttribute('data-key'), sel: '.vor-cl__name', fallback: fallback } : { fallback: fallback };
      theme.cart.changeItem(rm.getAttribute('data-key'), 0)
        .then(function (text) {
          var cart = JSON.parse(text);
          if (cart.status === 422 || !cart.sections) throw new Error(cart.message || 'change failed');
          document.dispatchEvent(new CustomEvent('cart:build', { detail: { sections: cart.sections } }));
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        })
        .catch(function () {
          busyEl.classList.remove('is-updating');
          window.location.href = rm.href;
        });
    }

    /* Minus at quantity 1 (data-vor-minus-remove) removes the line like Remove. Taken in the capture
       phase so theme.js's QtySelector on the button never runs (two removals of one key raced; UPP
       review 2026-10-18). */
    products.addEventListener('click', function (evt) {
      var adj = evt.target.closest && evt.target.closest('[data-vor-minus-remove]');
      var line = adj && adj.closest('.vor-cl');
      var rm = line && line.querySelector('[data-vor-remove]');
      if (!rm || !(window.theme && theme.cart && theme.cart.changeItem)) return;
      evt.stopPropagation();
      evt.preventDefault();
      removeLine(line, rm);
    }, true);

    // Clicks inside the lines: quantity (focus memory), Remove.
    products.addEventListener('click', function (evt) {
      var t = evt.target;
      var line = t.closest('.vor-cl');
      var adj = t.closest('.js-qty__adjust');
      if (adj && line) {
        clearAdded();
        refocus = { key: line.getAttribute('data-key'), sel: adj.classList.contains('js-qty__adjust--plus') ? '.js-qty__adjust--plus' : '.js-qty__adjust--minus' };
        return;
      }
      var rm = t.closest('[data-vor-remove]');
      if (rm && line && window.theme && theme.cart && theme.cart.changeItem) {
        evt.preventDefault();
        removeLine(line, rm);
      }
    });

    // Quantity typed into the field: keep focus on it after the refill.
    products.addEventListener('change', function (evt) {
      var line = evt.target.closest && evt.target.closest('.vor-cl');
      if (line && evt.target.classList.contains('js-qty__num')) {
        clearAdded();
        refocus = { key: line.getAttribute('data-key'), sel: '.js-qty__num' };
      }
    });
  }
  if (drawer) wire(drawer, true);
  if (page) wire(page, false);

  /* ---------- A23 consent ---------- */
  var KEY = 'vor-consent', ATTR = 'Sözleşme onayı';
  function stored() { try { return sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; } }
  function store(on) { try { sessionStorage.setItem(KEY, on ? '1' : '0'); } catch (e) {} }
  function consentRoot(el) { return el.closest('form') || el.closest('[data-vor-cart]') || document; }
  function applyConsent(root, on) {
    root.querySelectorAll('[data-vor-checkout]').forEach(function (b) {
      if (on) b.removeAttribute('aria-disabled'); else b.setAttribute('aria-disabled', 'true');
    });
    root.querySelectorAll('[data-vor-express]').forEach(function (x) { x.hidden = !on; });
    // #6: the collapsible's summary shows the state
    root.querySelectorAll('[data-vor-consent-state]').forEach(function (s) {
      s.textContent = on ? 'Onaylandı' : 'Onay gerekli';
      s.classList.toggle('is-ok', on);
    });
    if (on) {
      var err = root.querySelector('[data-vor-consent-err]');
      if (err) err.hidden = true;
      var box = root.querySelector('[data-vor-consent-box]');
      if (box) box.removeAttribute('aria-invalid');
    }
  }
  function consentValue(on) { return on ? 'evet · ' + new Date().toISOString() : ''; }
  // The cart form posts this hidden input with the checkout click, so the attribute reaches the order
  // even when the /cart/update.js write below fails.
  function setAttrInput(root, value) {
    root.querySelectorAll('[data-vor-consent-attr]').forEach(function (i) { i.value = value; });
  }
  function writeAttr(value) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var attrs = {}; attrs[ATTR] = value;
    return fetch(root + 'cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).then(function (r) { return r.ok; }).catch(function () { return false; });
  }
  // Write the attribute, retry once, and if it still fails keep the express buttons hidden: those skip
  // the cart form, so without the attribute on the cart the consent would leave no record on the order.
  function saveConsent(root, on) {
    var value = consentValue(on);
    setAttrInput(root, value);
    return writeAttr(value).then(function (ok) {
      if (ok) return true;
      return writeAttr(value).then(function (ok2) {
        if (!ok2 && on) {
          root.querySelectorAll('[data-vor-express]').forEach(function (x) { x.hidden = true; });
        }
        return ok2;
      });
    });
  }
  function blockCheckout(evt, root) {
    var box = root.querySelector('[data-vor-consent-box]');
    if (!box || box.checked) return false;
    evt.preventDefault();
    evt.stopImmediatePropagation();
    var err = root.querySelector('[data-vor-consent-err]');
    if (err) { err.hidden = false; err.textContent = err.textContent; }
    box.setAttribute('aria-invalid', 'true');
    // #6: the box lives in a collapsible; open it first so the focus lands on something visible
    var panel = box.closest('details');
    if (panel) panel.open = true;
    box.focus();
    return true;
  }
  // Clicks on the checkout button and every submit of the cart forms (Enter in a field submits with the
  // first submit button, the checkout one): taken in the capture phase, before theme.js's CartForm.
  document.addEventListener('click', function (evt) {
    var b = evt.target.closest && evt.target.closest('[data-vor-checkout]');
    if (b) blockCheckout(evt, consentRoot(b));
  }, true);
  document.addEventListener('submit', function (evt) {
    var f = evt.target;
    if (!f || !f.querySelector || !f.querySelector('[data-vor-checkout]')) return;
    var sub = evt.submitter;
    if (sub && sub.name !== 'checkout') return;
    blockCheckout(evt, f);
  }, true);
  document.addEventListener('change', function (evt) {
    var box = evt.target.closest && evt.target.closest('[data-vor-consent-box]');
    if (!box) return;
    store(box.checked);
    applyConsent(consentRoot(box), box.checked);
    saveConsent(consentRoot(box), box.checked);
  });
  // The checkout buttons are rendered disabled so that a tap landing before this file runs cannot submit
  // the form without the consent. From here the aria-disabled guard above takes over, which keeps the
  // error message and the focus move on a blocked click.
  document.querySelectorAll('[data-vor-checkout][disabled]').forEach(function (b) { b.disabled = false; });
  // first paint: the cart attribute (server) or this tab's earlier tick
  document.querySelectorAll('[data-vor-consent-box]').forEach(function (box) {
    if (!box.checked && stored()) {
      box.checked = true;
      saveConsent(consentRoot(box), true);
    }
    applyConsent(consentRoot(box), box.checked);
  });

  // "Sipariş notu ekle"
  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest && evt.target.closest('[data-vor-note-toggle]');
    if (!btn) return;
    var wrap = document.getElementById(btn.getAttribute('aria-controls'));
    if (!wrap) return;
    var open = btn.getAttribute('aria-expanded') !== 'true';
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    wrap.hidden = !open;
    if (open) {
      var ta = wrap.querySelector('textarea');
      if (ta) ta.focus();
    }
  });
})();
